var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"color":"secondary"},on:{"click":function($event){return _vm.$emit('click', $event)}},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('nv-circular-loader')]},proxy:true}])},'v-btn',_vm.$attrs,false),[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi-check-all")]),_c('span',[_vm._v("Approve")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }